import Vue from 'vue';
export default Vue.extend({
    name: 'NpsBadge',
    props: {
        npsValue: { type: Number, default: null }
    },
    computed: {
        badgeClass() {
            if (this.npsValue <= 6) {
                return 'detractor';
            }
            else if (this.npsValue <= 8) {
                return 'passive';
            }
            else if (this.npsValue > 8) {
                return 'promoter';
            }
            else if (!this.npsValue) {
                return 'no-value';
            }
            else {
                console.warn(`NPS out of range detected in Nps Badge component, with a value of ${this.npsValue}`);
                return undefined;
            }
        }
    }
});
